<template>
    <div>
       <b-avatar variant="info" v-if="projectImage" :src="projectImage" class="mr-3 avatar avatar-md rounded-circle" v-bind:class="project.iconColor"></b-avatar>
       <b-avatar variant="primary" v-else :text="projectInitials" class="mr-3" v-bind:class="project.iconColor"></b-avatar>
    </div>
</template>

<script>

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    projectImage() {
      return this.project.icon ? this.project.icon : '';
    },
    projectInitials() {
      return this.project.name.charAt(0).toUpperCase() + this.project.name.charAt(0).toUpperCase();
    },
  },
  methods: {
  },
};
</script>

<style scoped>
.b-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    flex-shrink: 0;
    width: 2.5rem;
    height: 2.5rem;
    font-size: inherit;
    font-weight: 400;
    line-height: 1;
    max-width: 100%;
    max-height: auto;
    text-align: center;
    overflow: visible;
    position: relative;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.mr-3, .mx-3 {
    margin-right: 1rem!important;
}
.rounded-circle {
    border-radius: 50%!important;
}
.badge-primary {
    color: #fff;
    background-color: #007bff;
}
</style>
